import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import ReportBox from './reportBox';
import count from './count';

const TotalServiceSales = ({ report, shortCount, showGiftCards }) => {
  let data = [{
    title: t('reports:total_service_sales.squire'),
    amount: report.paidViaSquireAmount,
    count: count(report.paidViaSquireCount, shortCount),
    tooltip: t('reports:total_service_sales.squire_tooltip'),
  }, {
    title: t('reports:total_service_sales.in_shop_pos'),
    amount: report.paidInShopViaPosAmount,
    count: count(report.paidInShopViaPosCount, shortCount),
    tooltip: t('reports:total_service_sales.pos_cash_tooltip'),
  }, {
    title: t('reports:total_service_sales.in_shop_cash'),
    amount: report.paidInShopOtherAmount,
    count: count(report.paidInShopOtherCount, shortCount),
    tooltip: t('reports:total_service_sales.pos_cash_tooltip'),
  }, {
    title: t('reports:total_service_sales.gift_card'),
    amount: report.paidViaGiftCardAmount,
    count: count(report.paidViaGiftCardCount, shortCount),
  }, {
    title: t('reports:total_service_sales.net_total'),
    amount: report.totalAmount,
    count: count(report.totalCount, shortCount),
    tooltip: t('reports:total_service_sales.net_total_tooltip'),
  }, {
    title: t('reports:total_service_sales.discounts_promos_loyalty'),
    amount: report.totalDiscount,
    count: count(report.discountCount, shortCount),
  }, {
    title: t('reports:total_service_sales.total'),
    amount: report.totalAmount + report.totalDiscount,
    count: count(report.totalCount, shortCount),
  }];

  if (!showGiftCards) {
    data = data.filter(({ title }) => title !== t('reports:total_service_sales.gift_card'));
  }

  const content = data.map((item, index) => (
    <ReportBox key={index} {...item} />
  ));

  return (
    <div className="layout u-mv-">{content}</div>
  );
};

TotalServiceSales.propTypes = {
  report: PropTypes.object.isRequired,
  shortCount: PropTypes.bool,
  showGiftCards: PropTypes.bool.isRequired,
};

TotalServiceSales.defaultProps = {
  shortCount: false,
};

export default TotalServiceSales;
